import React, { useEffect, useState } from 'react';
import Modal2 from "../../components/modalsus2026/ModalSus";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [t, i18n] = useTranslation("global");
    const [t2] = useTranslation("footer");
    const [t3] = useTranslation("detail_blog");

    const openModal2 = () => {


        setIsModalOpen2(true);
    };

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Footer',
            event_label: label,
            value: 1
        });
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    return (
        <>
            <div class="_ngcontent-ng-c1842723448 _nghost-ng-c2025359582">
                <div class="back-to-top"><button type="button"
                    class="back-to-top__button" onClick={() => {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                        trackAnalyticsClick('Footer - Regresar arriba');
                    }
                    }><span>{(t3('2026.top'))}</span><img
                        src="/assets/img2026/chevron_up.svg" alt="Regresar arriba" aria-hidden="true"
                        class="back-to-top__icon" /></button></div>
            </div>
            <div class="_nghost-ng-c375188887">
                <footer className="bottom">
                    <div className="bottom__main">

                        <div className="bottom__intro">
                            <div className="bottom__brand">
                                <a onClick={() => trackAnalyticsClick('Footer - Inicio')} href='/'>
                                    <img
                                        src="/assets/img2026/logo_rs.svg"
                                        alt="Ricardo Salinas"
                                        className="bottom__brand-logo"
                                    />
                                </a>
                            </div>

                            <span className="bottom__divider bottom__divider--intro" />

                            <div className="bottom__social">
                                <p className="bottom__social-title" dangerouslySetInnerHTML={{ __html: (t('general.follow')) }} ></p>

                                <a onClick={() => trackAnalyticsClick('Footer - Redes: Twitter')} className="bottom__social-link" target='_blank' href="https://x.com/ricardobsalinas" aria-label="X">
                                    <img src="/assets/img2026/logo_twitter.svg" alt="X" />
                                </a>

                                <a onClick={() => trackAnalyticsClick('Footer - Redes: Facebook')} className="bottom__social-link" target='_blank' href="https://www.facebook.com/RicardoSalinasPliego" aria-label="Facebook">
                                    <img src="/assets/img2026/logo_facebook.svg" alt="Facebook" />
                                </a>

                                <a onClick={() => trackAnalyticsClick('Footer - Redes: Instagram')} className="bottom__social-link" target='_blank' href="https://www.instagram.com/ricardosalinas/?hl=es-la" aria-label="Instagram">
                                    <img src="/assets/img2026/logo_instagram.svg" alt="Instagram" />
                                </a>

                                <a onClick={() => trackAnalyticsClick('Footer - Redes: Youtube')} className="bottom__social-link" target='_blank' href="https://www.youtube.com/channel/UCovDaTdisIRpyFqQsNGMNsQ" aria-label="Youtube">
                                    <img src="/assets/img2026/logo_youtube.svg" alt="Youtube" />
                                </a>

                                <a onClick={() => trackAnalyticsClick('Footer - Redes: Tiktok')} className="bottom__social-link" target='_blank' href="https://www.tiktok.com/discover/ricardo-salinas-pliego?lang=es" aria-label="TikTok">
                                    <img src="/assets/img2026/logo_tiktok.svg" alt="TikTok" />
                                </a>
                            </div>
                            <span className="bottom__divider bottom__divider--intro no-mov-a" />
                            <div className='footer-desk-s footer-desk-g'>
                                <div className="bottom__social-title ">{t2("footer.contact")}</div>
                                <div className="">
                                    <p className="">
                                        <a onClick={() => trackAnalyticsClick('Footer - Contacto Mailto')} href="mailto:comentarios.ricardosalinas@gruposalinas.com.mx">
                                            comentarios.ricardosalinas@gruposalinas.com.mx
                                        </a>
                                    </p>
                                    <p>
                                        Periférico Sur #4277 piso 8, Col. Jardines de la
                                        Montaña, Tlalpan, 14210 CDMX, México
                                    </p>
                                </div>
                            </div>
                        </div>

                        <span className="bottom__divider bottom__divider--desktop only-help" />

                        <button type="button" className="bottom__newsletter-button footer-mov-s" onClick={() => {openModal2();trackAnalyticsClick('Footer - Suscribirse')}}>
                            {(t('general.suscribirsebtn'))}
                        </button>
                        <div className='footer-desk-s footer-desk-t'>
                            <div className="titl-foot-a">{t2("footer.contact")}</div>
                            <div className="">
                                <p className="">
                                    <a onClick={() => trackAnalyticsClick('Footer - Contacto Mailto')} href="mailto:comentarios.ricardosalinas@gruposalinas.com.mx">
                                        comentarios.ricardosalinas@gruposalinas.com.mx
                                    </a>
                                </p>
                                <p>
                                    Periférico Sur #4277 piso 8, Col. Jardines de la <br />
                                    Montaña, Tlalpan, 14210 CDMX, México
                                </p>
                            </div>
                        </div>

                        <span className="bottom__divider bottom__divider--desktop" />
                        <span className="bottom__divider bottom__divider--mobile" />

                        <div className="bottom__company">
                            <a className='centro-tab' onClick={() => trackAnalyticsClick('Footer - Centro RBS')} target='_blank' href='https://www.centroricardobsalinaspliego.org/' >
                                <img className='img22' src="/assets/img2026/logo-centro2.png" alt="Centro Ricardo B. Salinas Pliego" />
                            </a>
                            <a className='universidad-tab' onClick={() => trackAnalyticsClick('Footer - Universidad')} target='_blank' href='https://www.ulibertad.edu.mx/es' >
                                <img src="/assets/img2026/universidad-l.svg" alt="Universidad de la Libertad" />
                            </a>
                            <a className='grupo-tab' onClick={() => trackAnalyticsClick('Footer - Grupo Salinas')} target='_blank' href='https://www.gruposalinas.com/' >
                                <img src="/assets/img2026/grupo-salinas-l.svg" alt="Grupo Salinas" />
                            </a>
                            <div className="only-tablet-reservado">
                                <p>{(t('general.reservado'))}</p>
                                <a target='_blank' onClick={() => trackAnalyticsClick('Footer - Aviso')} href="https://ricardosalinas.com/content/assets/documents/Aviso-de-Privacidad-05032024.pdf"> {(t('general.aviso'))}</a>
                            </div>
                        </div>
                    </div>

                    <div className="bottom__legal">
                        <p>{(t('general.reservado'))}</p>
                        <a target='_blank' onClick={() => trackAnalyticsClick('Footer - Aviso')} href="https://ricardosalinas.com/content/assets/documents/Aviso-de-Privacidad-05032024.pdf"> {(t('general.aviso'))}</a>
                    </div>
                </footer>
                <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
            </div>
        </>
    );
};

export default Footer;